<template>

    <div>
        <v-flex class="mx-auto pt-10 text-center white--text">
            <img src="../assets/icon_outline.png" height="60" width="60"/><br>
            ITALIA<strong>SOFTAIR</strong>
        </v-flex>

        <v-flex class="mx-auto pa-5">
            <v-card elevation="10" class="pa-5 pb-8">
                <v-form ref="login" v-model="valid" lazy-validation @submit.prevent="validate">
                    <v-text-field prepend-icon="mdi-account-circle" v-model="credentials.email" :rules="emailRules"
                                  label="E-mail" required></v-text-field>
                    <v-text-field prepend-icon="mdi-lock" type="password" v-model="credentials.password"
                                  :rules="passwordRules"
                                  label="Password" required></v-text-field>
                    <v-btn tile block large :disabled="!valid" color="teal darken-1" class="mt-4" type="submit">Accedi
                    </v-btn>
                </v-form>
            </v-card>
        </v-flex>

        <v-flex class="mx-auto px-10">
            <p class="pt-10 px-10 text-center white--text">
                Non hai ancora registrato il tuo <strong>Club</strong> e il tuo <strong>Account</strong>?
                <br>
                <v-btn to="/site" class="mt-2" outlined color="white">Registrati ora!</v-btn>
            </p>
        </v-flex>

        <v-footer
                dark
                padless
                fixed
        >
            <v-card
                    class="flex"
                    flat
                    tile
            >
                <v-card-text class="py-3 white--text text-center">
                    <small>Vers. {{VERSION}}</small>
                </v-card-text>
            </v-card>
        </v-footer>

    </div>
</template>

<script>
    import {mapActions, mapState, mapGetters} from 'vuex'

    export default {
        name: "Login",
        data: () => ({
            valid: true,
            credentials: {
                email: '',
                password: '',
            },
            emailRules: [
                v => !!v || 'Inserire un email!',
                v => /.+@.+\..+/.test(v) || 'Inserire un email valida!',
            ],
            passwordRules: [
                v => !!v || 'Inserire una password!',
            ],
        }),

        beforeCreate() {
            if(this.isLoggedIn){
                //console.log('ciao')
               this.$router.go(-1);
            }
        },
        computed: {
            ...mapState([
                'VERSION'
            ]),
            ...mapGetters([
                'isLoggedIn'
            ])
        },

        methods: {
            ...mapActions([
                '_Login'
            ]),
            validate() {
                if (this.$refs.login.validate()) {
                    this._Login(this.credentials);
                }
            },
        },
    }
</script>

<style scoped>

</style>